<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="品牌名称">
                  <el-input property="请填写品牌名称" v-model="queryForm.brandName" style="width: 200px"></el-input>
              </el-form-item>
              <el-form-item label="品牌分类">
                  <el-select
                      placeholder="请选择品牌分类"
                      clearable
                      style="width: 200px"
                      size="small"
                      v-model="queryForm.categoryId"
                  >
                      <el-option
                          v-for='(item,index) in categoryList'
                          :key='index'
                          :label="item.categoryName"
                          :value="item.id"
                      >
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMallHotelBrandList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMallHotelBrand"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMallHotelBrand(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMallHotelBrand(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportMallHotelBrandList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshMallHotelBrandList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mallHotelBrandList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="brandName"
        label="品牌名称"
        width="280"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="brandLogo"
        label="品牌LOGO"
        width="280"
      >
          <template slot-scope="scope">
              <el-image
                  @click='updateSrcList(scope.row.brandLogo)'
                  style="width: 30px; height: 30px"
                  :src="scope.row.brandLogo"
                  :preview-src-list="srcList"
              > </el-image>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="categoryId"
        label="分类"
        width="280"
      >
        <template slot-scope="scop">
            <div>{{computeCategory(scop.row.categoryId)}}</div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMallHotelBrand(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMallHotelBrand(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMallHotelBrand(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mallHotelBrandStates[mallHotelBrandState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mallHotelBrand"
          ref="mallHotelBrandForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="品牌名称"
            prop="brandName"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelBrand.brandName"
              :disabled="mallHotelBrandState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="品牌分类"
            prop="categoryId"
          >
              <el-select
                  placeholder="请选择是否显示"
                  clearable
                  style="width: 200px"
                  size="small"
                  v-model="mallHotelBrand.categoryId"
                  :disabled="mallHotelBrandState == 'check'"
              >
                  <el-option
                      v-for='(item,index) in categoryList'
                      :key='index'
                      :label="item.categoryName"
                      :value="item.id"
                  ></el-option>
              </el-select>
          </el-form-item>
            <el-form-item label="品牌LOGO" prop="productPic">
                <el-upload
                    :disabled="mallHotelBrandState == 'check'"
                    style="width: 200px"
                    class="avatar-uploader"
                    action=""
                    :show-file-list="false"
                    :http-request="uploadAvatar">
                    <img v-if="mallHotelBrand.brandLogo" :src="mallHotelBrand.brandLogo" class="avatar" size="small" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mallHotelBrandState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { UPLOAD_PATH } from '@/utils/constant';
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMallHotelBrandList();
                    this.getMallHotelBrandList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMallHotelBrandList();
                    this.getMallHotelBrandList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                srcList: [''],
                categoryList: [],

                queryForm:{
                     brandName: '', //品牌名称
                     brandLogo: '', //品牌LOGO
                     categoryId: '', //分类
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mallHotelBrandState: 'add',
                mallHotelBrandStates: {
                    add: '新建品牌',
                    check: '查看品牌',
                    edit: '修改品牌'
                },

                multipleSelection: [],
                mallHotelBrandList: [],
                mallHotelBrand: {
                    brandName: '', //品牌名称
                    brandLogo: '', //品牌LOGO
                    categoryId: '', //分类
                },
                btnLoading: false,

                rules: {
                    brandName: [{ required: true, message: '品牌名称不能为空', trigger: 'blur' }],
                    brandLogo: [{ required: true, message: '品牌LOGO不能为空', trigger: 'blur' }],
                    categoryId: [{ required: true, message: '分类不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMallHotelBrandCategory();
            this.getMallHotelBrandList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMallHotelBrandList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mallHotelBrandList = [];
            },
            resetDialog() {
                this.mallHotelBrandState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      brandName: '', //品牌名称
                      brandLogo: '', //品牌LOGO
                      categoryId: '', //分类
                };
                this.getMallHotelBrandList();
            },
            closeDialog() {
                this.showDialog = false
                this.mallHotelBrand = {
                      brandName: '', //品牌名称
                      brandLogo: '', //品牌LOGO
                      categoryId: '', //分类
                };
            },
            submitForm() {
                if (this.mallHotelBrandState == 'add') {
                    this.$refs.mallHotelBrandForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mall/hotelbrand/add`,{ ...this.mallHotelBrand }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMallHotelBrandList();
                                    this.resetDialog();
                                    this.getMallHotelBrandList();
                                }
                            });
                        }
                    });
                } else if (this.mallHotelBrandState == 'edit') {
                    this.$refs.mallHotelBrandForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.mallHotelBrand.category

                            post(`/mall/hotelbrand/edit`,{ ...this.mallHotelBrand }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMallHotelBrandList();
                                    this.resetDialog();
                                    this.getMallHotelBrandList();
                                }
                            });
                        }
                    });
                }
            },
            addMallHotelBrand() {
                this.showDialog = true;
                this.mallHotelBrandState = 'add';
            },
            checkMallHotelBrand(mallHotelBrandId) {
                console.log(mallHotelBrandId);
                this.currentMallHotelBrandId = mallHotelBrandId;

                this.getMallHotelBrandById();
                this.showDialog = true;
                this.mallHotelBrandState = 'check';
            },
            editMallHotelBrand(mallHotelBrandId) {
                console.log('mallHotelBrand', mallHotelBrandId);
                if (mallHotelBrandId) {
                    this.currentMallHotelBrandId = mallHotelBrandId;
                    this.getMallHotelBrandById();
                } else {
                    this.mallHotelBrand = { ...this.mallHotelBrand, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mallHotelBrandState = 'edit';
            },
            deleteMallHotelBrand(mallHotelBrandId) {
                let ids = '';
                if (mallHotelBrandId) {
                    ids = mallHotelBrandId;
                } else {
                    ids = this.multipleSelection.map((mallHotelBrand) => mallHotelBrand.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mall/hotelbrand/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMallHotelBrandList();
                                this.getMallHotelBrandList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMallHotelBrandList() {
                this.resetMallHotelBrandList();
                this.getMallHotelBrandList();
            },
            getMallHotelBrandList(query = {}) {
                this.loading = true;
                get(`/mall/hotelbrand/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mallHotelBrandList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getMallHotelBrandById() {
                get(`/mall/hotelbrand/get`,{ id: this.currentMallHotelBrandId }).then((res) =>{
                    if(res.success){
                      this.mallHotelBrand = { ...this.mallHotelBrand, ...res.mallHotelBrand };
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMallHotelBrandList() {
                //this.btnLoading = true;
                exprotExcel(`/mall/hotelbrand/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mall/hotelbrand/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mall/hotelbrand/importData`,formData);
              this.refreshMallHotelBrandList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMallHotelBrandList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMallHotelBrandList();
            },
            updateSrcList(src){
                this.srcList[0] = src
            },

            //上传缩略图
            uploadAvatar(params) {
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                if (!types.includes(file.type)) {
                    this.$message.error('图片类型错误!');
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(UPLOAD_PATH, formData).then((res) => {
                    if (res.success) {
                        this.mallHotelBrand.brandLogo = res.url;
                    }
                });
            },

            // 获取全部的品牌类型
            getMallHotelBrandCategory(){
                get('/mall/hotelbrandcategory/findAll').then((res)=>{
                    if(res.success){
                        this.categoryList = res.list
                    }
                })
            },

            // 计算品牌类型
            computeCategory(id){
                for (let i = 0; i < this.categoryList.length; i++) {
                    if(this.categoryList[i].id == id){
                        return this.categoryList[i].categoryName
                    }
                }
            },
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
</style>